import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination } from "swiper/modules";

// Images
import washingtouch from "../image/touchm.png";
import washingMachine3 from "../image/f3.png";
import tv2 from "../image/Screen Size 43-50.png";
import Ac from "../image/AC2S.png";
import dishwasher from "../image/f1.png";
import touchcooler from "../image/SAC.png";
import Micro from "../image/micro oven.png";
import mixer from "../image/Mixer_2.png";

// Category Data
const categories = [
  { id: 1, title: "Washing Machine", img: washingtouch, bg: "bg-green-200", type: "luxury-appliances" },
  { id: 3, title: "Refrigerator", img: washingMachine3, bg: "bg-cyan-200", type: "luxury-appliances" },
  { id: 2, title: "Television", img: tv2, bg: "bg-yellow-200", type: "luxury-appliances" },
  { id: 7, title: "Air Cooler", img: touchcooler, bg: "bg-amber-200", type: "luxury-appliances" },
  { id: 4, title: "Air Conditioner", img: Ac, bg: "bg-pink-200", type: "luxury-appliances" },
  { id: 5, title: "Dishwasher", img: dishwasher, bg: "bg-teal-200", type: "luxury-appliances" },
  { id: 6, title: "Microwave Oven", img: Micro, bg: "bg-red-200", type: "luxury-appliances" },
  { title: "Small Appliance", img: mixer, bg: "bg-cyan-200", type: "small-appliances" },
];

const SelectProduct = () => {
  return (
    <div className="bg-white py-3 ">
      {/* Grid for large screens */}
      <div className="hidden md:grid mt-[80px] mx-auto grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 lg:grid-cols-8 gap-4">
        {categories.map((category, index) => (
          <Link
            key={index}
            to={category.title === "Small Appliance" ? `/${category.type}` : `/${category.type}/${category.id}`}
            className="flex flex-col items-center "
          >
            {/* Use responsive classes: smaller on mobile (default), larger on md+ */}
            <div className={`w-15 h-15 md:w-20 md:h-20 flex items-center justify-center border-2 border-orange rounded-full ${category.bg}`}>
              <img src={category.img} alt={category.title} className="w-12 h-12 md:w-16 md:h-16 object-contain" />
            </div>
            <p className="text-sm md:text-sm  text-black text-center">{category.title}</p>
          </Link>
        ))}
      </div>

      {/* Swiper Slider for small screens */}
      <div className="md:hidden mt-[70px]">
        <Swiper
          slidesPerView={5}
          spaceBetween={15}
          freeMode={true}
          pagination={{ clickable: true }}
          modules={[FreeMode, Pagination]}
          className="mySwiper"
        >
          {categories.map((category, index) => (
            <SwiperSlide key={index}>
              <Link
                to={category.title === "Small Appliance" ? `/${category.type}` : `/${category.type}/${category.id}`}
                className="flex flex-col items-center space-y-2"
              >
                <div className={`w-16 h-16 md:w-20 md:h-20 flex items-center justify-center border-2 border-orange rounded-full ${category.bg}`}>
                  <img src={category.img} alt={category.title} className="w-12 h-12 md:w-16 md:h-16 object-contain" />
                </div>
                <p className="text-xs md:text-sm text-black text-center">{category.title}</p>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default SelectProduct;
